import React from "react";

import "./VendorsDetails.scss";

const VendorProfile = () => {
  return <h2>Hello world</h2>;
};

export default VendorProfile;
